import { Platform } from 'react-native'
import { ResultValueType, ResultVariant } from './types'

export const REVIEW_MASK_PADDING = Platform.select({ default: 32, web: 64 })
export const REVIEW_MASK_BORDER_RADIUS = 32

/** Flat 75% black for now — kept as three stops so the curve is easy to tune later. */
export const REVIEW_MASK_GRADIENT_OPACITY_TOP = 0.75
export const REVIEW_MASK_GRADIENT_OPACITY_MIDDLE = 0.75
export const REVIEW_MASK_GRADIENT_OPACITY_BOTTOM = 0.75

export const sContainerOuter =
  'flex w-full flex-col items-start justify-between gap-8 overflow-hidden rounded-2xl bg-white px-8 pb-16 pt-10'

export const sContainerHeader =
  'flex w-full flex-col items-center justify-center gap-2 px-8'

export const resultTypeToVariant: Record<ResultValueType, ResultVariant> = {
  automatic: 'success',
  manual: 'attention',
}
